import Vue from 'vue';
import store from './store';
import router from './router';

import './mixins';
import './thirdparty';
import ajax from '@/services/base.service.js';

//-- Meta rewriting
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

//-- Basic bootstrap
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

//-- V-Select
import "vue-select/dist/vue-select.css";

//import 'font-awesome/css/font-awesome.min.css';
import './scss/core.scss';

import AppLayout from './layout/Index.vue';

Vue.config.productionTip = false;

const API = {
    install(Vue, options) {
        Vue.prototype.$AJAX = ajax;
    }
};

Vue.use(API);

(() => new Vue({
    name: 'Root',
    template: '<AppLayout />',
    components: { 
        AppLayout , 
    },
    el: '#app',
    router,
    store,
    mounted() {
        //console.log(router)
        router.beforeEach((to, from, next) => {
            //-- Rewrite title for admin               
            if (to.meta.front === false)
                this.$updatePageTitle(to, from, next);
              next();
        })
        
        router.afterEach((to, from, next) => {
            //console.log("ROUTER -> "+to.meta.auth);
            if (to.meta.auth === true)
            {
                //console.log(to.meta);
                this.$checkAuth();
            }
            else
                this.$checkUser();
        });

        //-- Adding header for xht USED FOR uploading the images / files
        XMLHttpRequest.prototype.origOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open   = function () {
            this.origOpen.apply(this, arguments);
            //this.setRequestHeader('X-TOKEN', 'the token');
            this.withCredentials = true;
        };

        //-- Clearing array izi
        Array.prototype.clear = function() {
            while (this.length > 0) {
                this.pop();
            } // Fastest
        };

        //-- Used to compare date in an array (find doesn't work)
        Array.prototype.indexOfDate = function (date) {
            for (var i = 0; i < this.length; i++) {
                if (+this[i] === +date) return i;
            };
            return -1;
        };
        

    }
}))();



// WEBPACK FOOTER //
// ./src/app.init.js